import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 日期美化
// import { dateFormat } from '../../utils/utils';
// 图片处理
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

const Content = ({ content }) => {
    console.log(content);

    return (
        // 数组必须添加根节点div，不然chip碎片只会展示包裹第一个div
        <div>
            {content.map((item, index) => {
                const { title, thumbnails, url } = item;

                return (
                    <div className={styles.content} key={index}>
                        <div className={styles.slide}>
                            <a href={url} target="_blank" rel="noreferrer">
                                <img src={formatImage(getThumbnail(item))} alt="" className={styles.slideImg} />
                                <div className={styles.itemTitle}>{title}</div>
                            </a>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Content);
